import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from 'src/app/services/search/search.service';
import { SpecialRoutingService } from 'src/app/services/special-routing/special-routing.service';
import { ChangeDetectorRef } from '@angular/core';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { inject } from '@angular/core';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';


@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  newestPubListResults: any[] = [];
  isLoading: boolean = false;
  username: string = localStorage.getItem('username') || '';

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private searchService: SearchService,
    public specialRoutingService: SpecialRoutingService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
    public auth: RxAuthService
  ) {}

  ngOnInit(): void {
    this.searchService.searchNewestPubLists().subscribe(
      (response) => {
        this.newestPubListResults = response.results;
        this.cdr.detectChanges(); // Manually trigger change detection
      },
      (error: any) => {
        console.error('Error searching RCL', error.message);
      }
    );
  }

  handleSearch(searchValue: string) {
    if (searchValue && searchValue.trim()) {
      const encodedSearchValue = encodeURIComponent(searchValue.trim());
      this.router.navigate(['/explore'], {
        queryParams: { search: encodedSearchValue },
      });
    } else {
      this.router.navigate(['/explore'], {
        queryParams: { search: '' },
      });
    }
  }

  logInfoAndReroute(result: any): void {
    const slug = result.rcl.slug;
    const id = result.rcl.id;
    this.loaderService.getIsLoading().subscribe((isLoading) => {
      this.isLoading = isLoading;
    });
    const route = this.specialRoutingService.prepareRoute('/profile', slug, id);

    this.specialRoutingService.redirectToRoute(route);
  }

  createClickHandler(result: any): () => void {
    return () => this.logInfoAndReroute(result);
  }

  // Add your form submission logic here
}
